<div class="field"
     [ngClass]="{'disabled': isDisabled, 'error': hasErrors()}"
     [hidden]="isHidden || isReadOnly"
>
  <label *ngIf="controlOptions.label">{{controlOptions.label}}</label>
  <div class="field" style="position: relative; line-height: 0em;">
    <div *ngIf="isLoading" class="ui small active loader"></div>
    <div *ngIf="controlOptions.isMultiselect; then muliselect else noMuliselect"></div>

    <ng-template #noMuliselect>
      <sui-select *ngIf="controlOptions.hint" class="selection"
                  [formControl]="formControlInstance"
                  (change)="onChange($event)"
                  suiPopup
                  popupText="{{controlOptions.hint}}"
                  [class.clearable]="clearable"
                  [options]="elements"
                  [labelField]="controlOptions.labelField"
                  [valueField]="controlOptions.valueField"
                  [isSearchable]="controlOptions.isSearchable"
                  #dxSuiSelect>
        <sui-select-option *ngFor="let option of dxSuiSelect.filteredOptions"
                           [value]="option"></sui-select-option>
      </sui-select>
      <sui-select *ngIf="!controlOptions.hint" class="selection"
                  [formControl]="formControlInstance"
                  (change)="onChange($event)"
                  [class.clearable]="clearable"
                  [options]="elements"
                  [labelField]="controlOptions.labelField"
                  [valueField]="controlOptions.valueField"
                  [isSearchable]="controlOptions.isSearchable"
                  #dxSuiSelect>
        <sui-select-option *ngFor="let option of dxSuiSelect.filteredOptions"
                           [value]="option"></sui-select-option>
      </sui-select>

    </ng-template>

    <ng-template #muliselect>
      <sui-multi-select *ngIf="controlOptions.hint" class="selection"
                        [formControl]="formControlInstance"
                        (change)="onChange($event)"
                        suiPopup
                        popupText="{{controlOptions.hint}}"
                        [options]="elements"
                        [labelField]="controlOptions.labelField"
                        [valueField]="controlOptions.valueField"
                        [isSearchable]="controlOptions.isSearchable"
                        [hasLabels]="controlOptions.hasLabels"
                        #dxSuiMultiSelect>
        <sui-select-option *ngFor="let option of dxSuiMultiSelect.filteredOptions"
                           [value]="option"></sui-select-option>
      </sui-multi-select>
      <sui-multi-select *ngIf="!controlOptions.hint" class="selection"
                        [formControl]="formControlInstance"
                        (change)="onChange($event)"
                        [options]="elements"
                        [labelField]="controlOptions.labelField"
                        [valueField]="controlOptions.valueField"
                        [isSearchable]="controlOptions.isSearchable"
                        [hasLabels]="controlOptions.hasLabels"
                        #dxSuiMultiSelect>
        <sui-select-option *ngFor="let option of dxSuiMultiSelect.filteredOptions"
                           [value]="option"></sui-select-option>
      </sui-multi-select>
    </ng-template>

    <img *ngIf="clearable && formControlInstance.value !== null"
          src="assets/img/dx-img/dx-core/dx-delete.svg"
         class="clearButton"
         (click)="formControlInstance.setValue(null)"/>

    <div *ngIf="hasErrors()" class="ui red pointing label">
      {{errorMessage}}
    </div>
  </div>
</div>

<div class="field"
     *ngIf="isReadOnly"
     [hidden]="isHidden">
  <label *ngIf="controlOptions.label">{{controlOptions.label}}</label>
  <span class="readonlyValue">{{getValueAsLabel()}}</span>
</div>
